module.exports = __webpack_public_path__ + "static/media/Jean.b51565c6.png";